<template> <!--TO DO! change hard coded lookup to api form lookup-->
    <div >
        <div class="row">
            <div class="col">
                <q-btn-toggle
                    spread
                    v-model="Form.AmountUnits"
                    toggle-color="primary"
                    :options="[
                        {label: 'Amount', value: 'Amount'},
                        {label: 'Units', value: 'Units'}
                    ]"
                    @input="AmountUnitSelection(Form.AmountUnits)"
                />
            </div>
        </div>
        <div class="row" v-if="Form.AmountUnits==='Units'">
            <div class="col">
                <q-toggle
                    v-model="Form.RedeemAllUnits"
                    label="Redeem All Units"
                    left-label
                    @input="PopulateAllUnits()"
                />
            </div>
        </div>
        <br>
        <div class="row">
            <div bottom-slots class="col" v-if="Form.AmountUnits!=='Amount'">
                <q-input 
                v-model.lazy="price"
                v-money="money"
                outlined 
                v-model="Form.Units" 
                label="Units" 
                :readonly="Form.RedeemAllUnits"
                lazy-rules
                :rules="[ val => RemoveFormat(val) <= Number(BalanceUnit) && val !== '' && val !== 0 || 'Must not more than ' + BalanceUnit.toLocaleString(undefined, {minimumFractionDigits: 0,maximumFractionDigits: 2}) + ' units']" 
                />
            </div>

            <div bottom-slots class="col" v-else-if="Form.AmountUnits==='Amount' ">
                
                <q-input 
                prefix="MYR"
                filled
                outlined
                v-model.lazy="price"
                v-money="money"
                v-on:keyup="RemoveFormat(Form.Amount)"
                v-model="Form.Amount" 
                label="Amount"                
                :rules="[ val => RemoveFormat(val) <= Number(BalanceAmount) && val !== '' && val !== 0 || 'MYR ' +val + ' Must not more than MYR' + BalanceAmount.toLocaleString(undefined, {minimumFractionDigits: 0,maximumFractionDigits: 2})]"              
                />
                <br>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <q-select 
                    v-if="Plan!=='EPF'"
                    filled 
                    v-model="Form.PaymentInstruction" 
                    :options="PaymentInstructionOptions" 
                    label="Payment Instruction" 
                />
                <q-input
                    v-if="Plan==='EPF'"
                outlined
                    label="EPF No"
                    v-model="StoreStateCD.CustomerDetails.EPFNo" 
                    readonly
                />
            </div>
        </div>
    </div>
</template>

<script>
import store from '../store';  
import {VMoney} from 'v-money'
import { mapState, mapActions } from "vuex";
export default {
    name: 'FundTransactionRedemption',
    components: {
        
    },
    props: ['BalanceUnit','BalanceAmount','Plan'],
    data () {
        return {
            StoreStateProduct : store.state.Product,
            StoreStateCD : store.state.CD,
            StoreStateBAD : store.state.BAD,
             money: {
                decimal: '.',
                thousands: ',',
                precision: 2,
                masked: false /* doesn't work with directive */
                },
            Form : {
                AmountUnits : 'Amount',
                Amount : 0,
                Units : 0,
                RedeemAllUnits : false,
                Instruction : '',
                PaymentInstruction : '',
                Plan : 'EPF',
                PRSWithdrawalReason : '',
            },
            tempAmount : null,
            Amount : false,
            AddBankAccount : false,
            PaymentInstructionOptions : []
        }
    },
    directives: {money: VMoney},
    methods : {
    ...mapActions(["UpdateFundList","GetListOfFund"]),
       RemoveFormat (obj){
           var vall= obj;
           vall = vall.replace(",","");
           return vall.trim()
       },
        FilterFund (val, update, abort) {
            update(() => {
                const needle = val.toLowerCase()
                this.StoreStateProduct.FundList = this.StoreStateProduct.FundOptions.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            })
        },
        AmountUnitSelection(selItem){
            this.Form.Units = 0;
            this.Form.Amount = 0;
        },
        PopulateAllUnits(){
            if(this.Form.RedeemAllUnits===true){
                this.Form.Units = this.BalanceUnit
            }
            else{
                this.Form.Units = 0
            }
        },
        GetFund(){
            var Agree = false;
            if(this.Form.DisagreeRecommendation===false){
                Agree = true;
            }
            else
            if(this.Form.DisagreeRecommendation===true){
                Agree = false;
            }
            if(Number(this.StoreStateCD.SAT.Score) > 0 ){ 
                this.GetListOfFund({Plan:this.Form.Plan,Agree:Agree})
            }
            else{
                this.Form.Instruction = '';
                this.$q.dialog({
                    title: 'Message',
                    message: 'Kindly complete Suitability Assessment.',
                })
                .onOk(() => {
                    this.$router.push({name : 'sat'})
                })
                .onCancel(() => {
                    
                })
            }
        },
    },
    filters: {
		    thousandSeparator: function(value) {
		        if (value !== '' || value !== undefined || value !== 0  || value !== '0' || value !== '') {
                    value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                     var result = value;
                     return parseFloat(result).toFixed(2)
		        } else {
                    var result = value.toString();
                    return parseFloat(result).toFixed(2)
                }
     
          } 
    },
    mounted(){
        if(this.StoreStateCD.BankAccount.length<0){
            // to redirect to bank account page
            this.$q.dialog({
                title: 'Message',
                message: 'Kindly setup a bank account.',
            })
            .onOk(() => {
                this.$router.push({name : 'ClientBank'})
            })
            .onCancel(() => {
            })
            .onDismiss(() => {
            })
        }
        else{
            if(this.Plan!=='EPF'){
                this.PaymentInstructionOptions = []
                for(var i=0; i<this.StoreStateCD.BankAccount.length; i++){
                    this.PaymentInstructionOptions.push({
                        label : this.StoreStateCD.BankAccount[i].label + ' - ' + this.StoreStateCD.BankAccount[i].value,
                        value : this.StoreStateCD.BankAccount[i].value
                    })
                }
            }
        }
        
    }
    
}
</script>